export const BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? 'http://localhost:8080';
export const REALTIME_URL = import.meta.env.VITE_APP_REALTIME_WC_URL ?? import.meta.env.VITE_APP_BASE_URL;
export const ML_AUDIO_LENGTH_CAP = 60;
